import classNames from "classnames";
import { Fragment, SetStateAction, Dispatch, PropsWithChildren } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";

import { useIsMobile } from "../../../../shared/hooks/useIsMobile";

export interface IProps extends PropsWithChildren {
  open: boolean;
  setOpen: Dispatch<SetStateAction<any>>;
  title?: string;
  description?: string;
  styles?: {
    panel?: string;
    container?: string;
  };
  initialFocus?: any;
}

export default function DialogTwo({
  open,
  setOpen,
  title,
  children,
  description,
  styles = {}
}: IProps) {
  const isMobile = useIsMobile();

  function onClose() {
    setOpen(false);
  }

  return (
    <Transition.Root
      show={open}
      as={Fragment}
    >
      <Dialog
        as="div"
        className="relative z-50 "
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div
            className={classNames(
              "flex min-h-full justify-center text-center sm:items-center sm:p-0",
              !isMobile ? "items-end" : "items-center"
            )}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  "relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 mx-0 md:m-4 mb-0 rounded-b-none lg:rounded-b-lg w-full px-16 py-4",
                  styles?.panel || "max-w-fit md:min-w-max"
                )}
              >
                {title && (
                  <div className="mt-4 mb-8">
                    <div>
                      <button
                        className="float-right"
                        onClick={() => setOpen(false)}
                      >
                        <XMarkIcon className="w-6 h-6 text-gray-700 text-2xl" />
                      </button>
                    </div>
                    <Dialog.Title>
                      <p className="text-2xl font-medium mb-1">{title}</p>
                    </Dialog.Title>
                  </div>
                )}
                {description && (
                  <Dialog.Description>
                    <p className="text-sm text-gray-500">{description}</p>
                  </Dialog.Description>
                )}

                <div className="w-full">{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
